import { Draft, produce } from 'immer';

import {
  CONTRACT_SETUP__DOCUMENT_FIELDS_FETCH_REQUEST,
  CONTRACT_SETUP__DOCUMENT_FIELDS_FETCH_SUCCESS,
  CONTRACT_SETUP_ALL_STATE_CLEAR,
  CONTRACT_SETUP_FIELD_CREATE,
  CONTRACT_SETUP_FIELDS_OVER_MAX_DOCUMENT_PAGE_DELETE,
} from '@app/store/actionTypes';
import { ContractSetupAction } from '@app/store/contract-setup/actions';
import FieldType from '@app/store/FieldType';

export interface ContractSetupLatestFieldIdState {
  checkboxGroup: string | null;
  signatureField: string | null;
  textField: string | null;
}

const initialState: ContractSetupLatestFieldIdState = {
  checkboxGroup: null,
  signatureField: null,
  textField: null,
};

const reducer = produce(
  (draft: Draft<ContractSetupLatestFieldIdState>, action: ContractSetupAction) => {
    switch (action.type) {
      case CONTRACT_SETUP_ALL_STATE_CLEAR:
      case CONTRACT_SETUP__DOCUMENT_FIELDS_FETCH_REQUEST:
      case CONTRACT_SETUP_FIELDS_OVER_MAX_DOCUMENT_PAGE_DELETE:
        return initialState;
      case CONTRACT_SETUP__DOCUMENT_FIELDS_FETCH_SUCCESS: {
        const { participantFields } = action.payload;
        participantFields.forEach((participantField) => {
          const { fieldId, fieldType } = participantField;
          if (fieldType === FieldType.CHECKBOX_GROUP) {
            draft.checkboxGroup = fieldId;
          } else if (fieldType === FieldType.SIGNATURE_FIELD) {
            draft.signatureField = fieldId;
          } else if (fieldType === FieldType.TEXT_FIELD) {
            draft.textField = fieldId;
          }
        });
        return draft;
      }
      case CONTRACT_SETUP_FIELD_CREATE: {
        const {
          information: { type },
          meta: { uuid },
        } = action.payload;

        if (type === FieldType.CHECKBOX_GROUP) {
          draft.checkboxGroup = uuid;
        }
        if (type === FieldType.SIGNATURE_FIELD) {
          draft.signatureField = uuid;
        }
        if (type === FieldType.TEXT_FIELD) {
          draft.textField = uuid;
        }
        return draft;
      }
      default:
        return draft;
    }
  },
  initialState
);

export default reducer;
